export const SELECT_PRESET = (preset) => ({ type: 'SELECT_PRESET', payload: preset })

export const CREATE_PRESET = (preset) => ({ type: 'CREATE_PRESET', payload: preset })

export const UPDATE_PRESET = (preset) => ({ type: 'UPDATE_PRESET', payload: preset })

export const DELETE_PRESET = (presetId) => ({ type: 'DELETE_PRESET', payload: presetId })
